// Initialize dialogs when DOM is ready

import { ManagedDialogHandler } from './managed-dialog-handler';

document.addEventListener('DOMContentLoaded', function () {
    // The card zoom belongs to the Member ID card, which SSN sponsors don't render.
    if (
        /^\/.*\/register$/i.test(location.pathname) &&
        document.getElementById('mcpRegistrationCardZoom')
    ) {
        new ManagedDialogHandler(
            'mcpRegistrationCardZoom',
            '.close-dialog',
            '.mcp-registration-card-btn'
        );
    }
});
